import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import SlowMotionVideoIcon from "@mui/icons-material/SlowMotionVideo";
import MenuIcon from "@mui/icons-material/Menu";
import AboutUs from "@mui/icons-material/PersonPinCircleOutlined";

import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Drawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MailIcon from "@mui/icons-material/Mail";
import School from "@mui/icons-material/School";
import Support from "@mui/icons-material/Support";
import Camera from "@mui/icons-material/OndemandVideoOutlined";
import AccountCircle from "@mui/icons-material/AccountCircle";
import Facebook from "@mui/icons-material/Facebook";
import Twitter from "@mui/icons-material/Twitter";
import Campaign from "@mui/icons-material/Campaign";
import ArrowBackIos from "@mui/icons-material/ArrowBackIos";
import { ArrowBackIosNew } from "@mui/icons-material";
import Badge from "@mui/material/Badge";
import { openLink } from "../Script/script";
//import { LoginContext } from "../Context/loginContext";

const Menu = () => {
  const [buscar, setBuscar] = useState("");
  const [menu, setMenu] = useState(false);

  const pages = ["Products", "Pricing", "Blog"];
  const settings = ["Profile", "Account", "Dashboard", "Logout"];

  const handleBuscar = (e) => {
    setBuscar(e.target.value);
  };

  const mostrarMenu = (estado) => {
    setMenu(estado);
  };
  //const { email, handleLogout } = useContext(LoginContext);

  const history = useNavigate();

  /*useEffect(() => {
    //componentDidUnmount
    return () => handleLogout();
  });*/

  return (
    <header>
      <AppBar position="static" style={{ backgroundColor: "#0A2039" }}>
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <Box sx={{ flexGrow: 0 }}>
              <Avatar
                sx={{
                  width: 80,
                  height: 80,
                }}
                src="images/perfilmenu.png"
              />
            </Box>

            <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "flex" } }}>
              <Button
                variant="text"
                sx={{ color: "white" }}
                size="small"
                onClick={() => history("/start")}
              >
                <School />
                &nbsp;&nbsp;inicio
              </Button>
            </Box>

            <Box sx={{ flexGrow: 0, display: { xs: "none", md: "flex" } }}>
              <Button
                variant="text"
                sx={{ color: "white" }}
                size="small"
                onClick={() => history("/about")}
              >
                <AboutUs />
                &nbsp;Nosotros
              </Button>
            </Box>
            <Box sx={{ flexGrow: 0, display: { xs: "none", md: "flex" } }}>
              <Button
                variant="text"
                sx={{ color: "white" }}
                size="small"
                onClick={() => history("/cursos")}
              >
                <Camera />
                &nbsp;cursos
              </Button>
            </Box>
            <Box sx={{ flexGrow: 0, display: { xs: "none", md: "flex" } }}>
              <Button
                variant="text"
                sx={{ color: "white" }}
                size="small"
                onClick={() => history("/videos")}
              >
                <SlowMotionVideoIcon />
                &nbsp;videos
              </Button>
            </Box>
            <Box sx={{ flexGrow: 0, display: { xs: "none", md: "flex" } }}>
              <Button
                variant="text"
                sx={{ color: "white" }}
                size="small"
                onClick={() => history("/ayuda")}
              >
                <Support />
                &nbsp;Ayuda
              </Button>
            </Box>
            <Box sx={{ flexGrow: 0, display: { xs: "none", md: "flex" } }}>
              <Button
                variant="text"
                sx={{ color: "white" }}
                size="small"
                onClick={() => history("/suscriptor")}
              >
                <AccountCircle />
                &nbsp;suscríbete
              </Button>
            </Box>
            <Box sx={{ flexGrow: 0 }}>
              <Badge
                badgeContent={1}
                sx={{
                  "& .MuiBadge-badge": {
                    color: "white",
                    backgroundColor: "red",
                  },
                }}
              >
                <Button
                  variant="text"
                  sx={{ color: "white" }}
                  size="small"
                  onClick={() => mostrarMenu(true)}
                >
                  <MenuIcon />
                </Button>
              </Badge>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>

      <Drawer anchor={"right"} open={menu} onClose={() => mostrarMenu(false)}>
        <Box
          sx={{ width: "20em" }}
          role="presentation"
          onClick={() => mostrarMenu(false)}
          onKeyDown={() => mostrarMenu(false)}
        >
          <List>
            <ListItem button onClick={() => history("/")}>
              <ListItemIcon>
                <ArrowBackIos />
              </ListItemIcon>
              <ListItemText primary={"Inicio"} />
            </ListItem>
          </List>
          <List>
            <ListItem button onClick={() => history("/about")}>
              <ListItemIcon>
                <AboutUs />
              </ListItemIcon>
              <ListItemText primary={"Nosotros"} />
            </ListItem>
          </List>
          <List>
            <ListItem button onClick={() => history("/ayuda")}>
              <ListItemIcon>
                <Support />
              </ListItemIcon>

              <ListItemText primary={"Ayuda Online"} />
            </ListItem>
          </List>
          <List>
            <ListItem button onClick={() => history("/videos")}>
              <ListItemIcon>
                <SlowMotionVideoIcon />
              </ListItemIcon>
              <ListItemText primary={"Videos Gratuitos"} />
            </ListItem>
          </List>
          <List>
            <ListItem button onClick={() => history("/cursos")}>
              <ListItemIcon>
                <Camera />
              </ListItemIcon>
              <ListItemText primary={"Cursos de Programación"} />
            </ListItem>
          </List>
          <List>
            <ListItem button onClick={() => history("/anuncios")}>
              <ListItemIcon>
                <Campaign />
              </ListItemIcon>
              <Badge
                badgeContent={1}
                sx={{
                  "& .MuiBadge-badge": {
                    color: "white",
                    backgroundColor: "red",
                  },
                }}
              >
                <ListItemText primary={"Anuncios"} />
              </Badge>
            </ListItem>
          </List>
          <Divider />
          <List>
            <ListItem button onClick={() => history("/suscriptor")}>
              <ListItemIcon>
                <AccountCircle />
              </ListItemIcon>
              <ListItemText primary={"Suscríbete"} />
            </ListItem>
          </List>

          <List>
            <ListItem
              button
              onClick={() =>
                openLink("https://www.facebook.com/groups/sqldevscomunidad")
              }
            >
              <ListItemIcon>
                <Facebook />
              </ListItemIcon>
              <ListItemText primary={"Facebook"} />
            </ListItem>
          </List>
        </Box>
      </Drawer>
    </header>
  );
};

export default Menu;
